import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import VideoPrayers from "./Pages/VideoPrayers";
import Weddings from "./Pages/Weddings";
import Feasts from "./Pages/Feasts";
import History from "./Pages/History";
import Gallery from "./Pages/Gallery";
import AudioLibrary from "./Pages/AudioLibrary";
import Contact from "./Pages/Contact";
import Information from "./Pages/Information";
import Fasting from "./Pages/Fasting";
import PalmSunday from "./Pages/PalmSunday";
import News from "./Pages/News";
import NewsArticle from "./Pages/NewsArticle";

export default function MyRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/weddings" element={<Weddings />} />
      <Route path="/feasts" element={<Feasts />} />
      <Route path="/history" element={<History />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/audio-library" element={<AudioLibrary />} />
      <Route path="/video-prayers" element={<VideoPrayers />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/information" element={<Information />} />
      <Route path="/fasting" element={<Fasting />} />
      <Route path="/palm-sunday-2026" element={<PalmSunday />} />
      <Route path="/news" element={<News />} />
      <Route path="/news/:slug" element={<NewsArticle />} />
    </Routes>
  );
}
